import React from "react";

import "./Message.css";
const Message = (props) => {
  return (
    <div className="message-area text-center">
      <div className="message-content text-info">
        Seems as if you are not authenticated.
        <br />
        Please authenticate yourself before <br />
        to view the {props.item}
      </div>
    </div>
  );
};

export default Message;
